// src/data/projectData.js

const projectData = [
    {
      id: 1,
      title: 'Genix Flooring Wishlist App',
      image: 'https://via.placeholder.com/400x300',
      shortDesc: 'Custom Shopify app for managing wishlists on a flooring store.',
      fullDesc: 'Built a fully integrated wishlist Shopify app tailored for Genix Flooring, with persistent user sessions, design matching theme branding, and backend logic using Shopify APIs.',
    },
    {
      id: 2,
      title: 'JazzCash Payment Gateway App',
      image: 'https://via.placeholder.com/400x300',
      shortDesc: 'Custom payment app for Shopify using JazzCash API.',
      fullDesc: 'Created a Shopify app for integrating JazzCash as a payment method across stores, using Remix, PayFast integration, and Shopify App Bridge for secure checkout handling.',
    },
    {
      id: 3,
      title: 'Moonies Custom Shopify Store',
      image: 'https://via.placeholder.com/400x300',
      shortDesc: 'POD store built for Moonies brand with personalized artwork display.',
      fullDesc: 'Developed a personalized POD art store where product frames change dynamically based on selected size, using custom JavaScript and Shopify Liquid for dynamic UI logic.',
    },
    {
      id: 4,
      title: 'Typeform AI Product Sorter',
      image: 'https://via.placeholder.com/400x300',
      shortDesc: 'Typeform + OpenAI + Shopify integration for personalized shopping.',
      fullDesc: 'Built a Shopify integration that uses Typeform answers and OpenAI to generate personalized product suggestions and dynamically sort them on the storefront.',
    }
  ];
  
  export default projectData;  